import { CircularProgress, Grid } from '@mui/material';

function Loader() {
  return (
    <>
      <Grid
        sx={{
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 99999,
          WebkitUserSelect: 'none',
          KhtmlUserSelect: 'none',
          MozUserSelect: 'none',
          OUserSelect: 'none',
          userSelect: 'none',
        }}
      >
        <CircularProgress
          sx={{
            width: 90,
            height: 90,
            position: 'relative',
            color: '#7A7CE9',
          }}
        />
        <CircularProgress
          size={53}
          sx={{
            width: 90,
            height: 90,
            position: 'absolute',
            scale: '-1 1',
          }}
        />
      </Grid>
    </>
  );
}

export default Loader;
